export default __webpack_public_path__ + "static/media/sport-m.e83b27a5.svg";